export default __webpack_public_path__ + "static/media/20210801120724899_b.aae07ad8.jpg";